import { PaymentMethod } from '../../services/types/apitypes';
import {
  PreferredPayment,
  storageGetPreferredPayment,
  storageSetPreferredPayment,
} from '../../utils/storage';
import { AdditionalPaymentMethod } from './PaymentsList';

const toPreferredPayment = (
  payment: PaymentMethod | AdditionalPaymentMethod,
): PreferredPayment =>
  typeof payment === 'string'
    ? { kind: 'wallet', method: payment }
    : { kind: 'card', id: payment.id };

// Call after a payment succeeded, so the method is preselected next time.
export const rememberPaymentMethod = (
  payment: PaymentMethod | AdditionalPaymentMethod,
) => {
  storageSetPreferredPayment(toPreferredPayment(payment));
};

export const isLastUsedPaymentMethod = (
  payment: PaymentMethod | AdditionalPaymentMethod,
): boolean => {
  const preferred = storageGetPreferredPayment();
  if (!preferred) return false;
  return typeof payment === 'string'
    ? preferred.kind === 'wallet' && preferred.method === payment
    : preferred.kind === 'card' && preferred.id === payment.id;
};

// The method to preselect on a checkout screen: the last used one if it can
// still be used here, else the card marked default on the server, else the
// first card. `wallets` are the wallets this screen offers.
export const pickInitialPaymentMethod = (
  cards: PaymentMethod[],
  wallets: AdditionalPaymentMethod[],
): PaymentMethod | AdditionalPaymentMethod | undefined => {
  const preferred = storageGetPreferredPayment();
  if (preferred?.kind === 'card') {
    const card = cards.find((c) => c.id === preferred.id);
    if (card) return card;
  }
  if (preferred?.kind === 'wallet' && wallets.includes(preferred.method)) {
    return preferred.method;
  }
  return cards.find((c) => c.isDefault) ?? cards[0];
};
